import React, { useEffect, useRef } from "react";
import "./index.css";

const BEEHIIV_FORM_ID = "5e003a61-cf0d-4a15-b8a3-29e5e9760144";
const BEEHIIV_SCRIPT_SRC = "https://subscribe-forms.beehiiv.com/v3/loader.js";

const BeehiivForm = ({ className = "" }) => {
  const formContainerRef = useRef(null);

  useEffect(() => {
    const formContainer = formContainerRef.current;

    if (!formContainer) {
      return undefined;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = BEEHIIV_SCRIPT_SRC;
    script.setAttribute("data-beehiiv-form", BEEHIIV_FORM_ID);

    formContainer.innerHTML = "";
    formContainer.appendChild(script);

    return () => {
      formContainer.innerHTML = "";
    };
  }, []);

  return (
    <div className={`beehiiv-form ${className}`.trim()} ref={formContainerRef} />
  );
};

export default BeehiivForm;
